<template>
    <!-- Status: Voucher code unknown -->
    <div>
        <div v-if="voucher.unknown" class="avp-voucher-status avp-voucher-unknown">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.unknown.status.text') }}
            </p>
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.unknown.additional_information.text') }}
            </p>
            <i18n path="hotelVoucher.supporting_text.voucher.unknown.customer_support.text"
                  tag="p" class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
        </div>

        <!-- Status: Voucher code cancelled -->
        <div v-else-if="voucher.cancelled" class="avp-voucher-status avp-voucher-cancelled">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.cancelled.status.text') }}
            </p>
            <CustomerServiceBlock/>
        </div>

        <!-- Status: Voucher code already consumed -->
        <div v-else-if="voucher.consumed" class="avp-voucher-status avp-voucher-consumed">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.consumed.status.text') }}
            </p>
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.consumed.next_step.text') }}
            </p>
            <p class="text-center">
                <a :href="$t('footer.action.link_shop.url')" class="btn btn-primary">
                    {{ $t('hotelVoucher.action.voucher.consumed.text') }}
                </a>
            </p>
            <CustomerServiceBlock/>
        </div>

        <!-- Status: Voucher code is already expired -->
        <div v-else-if="voucher.servicesExpired && voucher.remainingAmountFormatted" class="avp-voucher-status avp-voucher-expired">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.services_expired.status.text') }}
            </p>
            <i18n path="hotelVoucher.supporting_text.voucher.services_expired.next_step.text" tag="p"
                  class="card-text">
                <template>{{voucher.remainingAmountFormatted}} &euro;</template>
            </i18n>

            <p class="text-center">
                <a :href="shopUrlWithCode" class="btn btn-primary">
                    {{ $t('hotelVoucher.action.voucher.services_expired.text') }}
                </a>
            </p>
            <CustomerServiceBlock/>
        </div>
        <div v-else-if="voucher.servicesExpired || voucher.expired" class="avp-voucher-status avp-voucher-expired">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.expired.status.text') }}
            </p>
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.expired.next_step.text') }}
            </p>
            <p class="text-center">
                <a :href="$t('footer.action.link_shop.url')" class="btn btn-primary">
                    {{ $t('hotelVoucher.action.voucher.expired.text') }}
                </a>
            </p>
            <CustomerServiceBlock/>
        </div>

        <!-- Status: Voucher code is valid, already activated but hotel is unavailable -->
        <div v-else-if="!voucher.hotelAvailable" class="avp-voucher-status avp-voucher-hotel-unavailable">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.hotel_unavailable.status.text') }}
            </p>
            <i18n path="hotelVoucher.supporting_text.voucher.hotel_unavailable.customer_support.text" tag="p"
                  class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
        </div>

        <!-- Status: Voucher code is valid and already activated -->
        <!--  Commented out since user will be redirected automatically to the booking service page-->
        <!--<div v-else-if="voucher.bookableHotelVoucher" class="avp-voucher-status avp-voucher-available">
            <p class="card-text">
                {{ $t('hotelVoucher.supporting_text.voucher.valid.next_step.text', { hotelname: voucher.hotelName }) }}
            </p>
            <div class="card-navigation">
                <button class="btn btn-primary" @click="gotoBookingService">
                    {{ $t('hotelVoucher.action.voucher.valid.text') }}
                </button>
            </div>
            <CustomerServiceBlock/>
        </div>-->

        <!-- Status: Fallback in case of an unknown state -->
        <div v-else>
            <p class="card-text text-secondary">
                {{ $t('hotelVoucher.supporting_text.unknown_state.status.text') }}
            </p>
            <i18n path="hotelVoucher.supporting_text.unknown_state.customer_support.text" tag="p"
                  class="card-text text-secondary">
                <CustomerServiceEmail/>
                <CustomerServicePhone/>
            </i18n>
        </div>
    </div>
</template>

<script>
    import CustomerServiceBlock from "./CustomerServiceBlock";
    import CustomerServiceEmail from "./CustomerServiceEmail";
    import CustomerServicePhone from "./CustomerServicePhone";

    export default {
        name: 'HotelVoucherStatusView',
        components: {CustomerServiceBlock, CustomerServicePhone, CustomerServiceEmail},
        computed: {
            shopUrlWithCode() {
                return this.$t('footer.action.link_shop.url') + "?code=" + this.voucher.voucherCode;
            },
            voucher() {
                return this.$store.state.voucher;
            }
        },
        methods: {
            gotoBookingService: function () {
                this.$emit( 'goto-bookingservice' );
            },
            exchangeVoucher: function () {
                location.href = "https://www.animod.de/widerruf?code=" + this.voucher.voucherCode
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .avp-contact-link {
        white-space: nowrap;
    }

    .avp-voucher-status {
        margin-bottom: 1.25rem;
    }

    .status-highlight {
        background-color: rgba(#fff, 0.5);
        padding: 0 0.3125rem;
    }
</style>
